// Arabisch (ar), reminders: zelfde vorm als reminders.nl.ts. De oproep op het bord: kort en
// vriendelijk, eenvoudige woorden voor kinderen.
export const kioskRemindersAr = {
    ok: 'حسنًا!',
    /** Rustig, buiten het thema Kinderen. */
    okCalm: 'حسنًا',
    speak: '{names}، {title}!',
    context: '{title} الساعة {time}',
    hint: 'بعد قليل: {title} · {time}',
    and: 'و',
    dialog: 'تذكير: {title}',
    okFor: 'حسنًا، {name}',
    checklist: 'في الحقيبة',
    checklistLeft: 'باقي {count}',
    checklistDone: 'كل شيء في الحقيبة!',
    checklistDoneCalm: 'كل شيء في الحقيبة',
    checklistItem: '{label}، {name}',
    checklistItemDone: '{label} في الحقيبة',
    taskContext: 'مهمة الساعة {time}',
};
//# sourceMappingURL=reminders.ar.js.map